import React from 'react'
import _ from 'lodash'

import {Link} from 'react-router'
import {Grid} from 'react-flexbox-grid'

import {Icon, Menu} from 'antd'

import {Footer} from './Footer.jsx'

export const Layout = ({auth, routes, footer, children, location}) => {
   const links = _.filter(routes[0].childRoutes, r => r.navigate)
   const paths = links.concat([{path: '/user/account', match: '/user'}, {path: '/user/logout'}])

   const activePaths = _.filter(paths, ({path, match}) =>
      location.pathname.match(match || path)
   ).map(({path}) => '/' + _.trim(path, '/'))

   return (
      <div className="layout">
         <div className="navbar" style={{background: '#222', borderBottom: '1px solid #080808'}}>
            <Grid>
               <Menu
                  theme="dark"
                  mode="horizontal"
                  selectedKeys={activePaths}
                  style={{background: '#222', borderColor: 'transparent'}}
               >
                  <Menu.Item className="branding">
                     <Link to="/">
                        <img
                           src={'./public/images/workbench-neg.png'}
                           width={100}
                           style={{paddingTop: '12px', display: 'block'}}
                        />
                     </Link>
                  </Menu.Item>

                  {_.map(links, (e, k) => (
                     <Menu.Item key={`/${e.path}`}>
                        <Link to={`/${e.path}`}>{e.name}</Link>
                     </Menu.Item>
                  ))}

                  {auth
                     ? <Menu.Item className="pull-right" key="/user/account">
                          <Link to="/user/account">
                             <Icon type="user" />
                             User Account
                          </Link>
                       </Menu.Item>
                     : null}
                  {auth
                     ? <Menu.Item className="pull-right" key="/user/logout">
                          <Link to="/auth/logout">
                             <Icon type="logout" />
                             Logout
                          </Link>
                       </Menu.Item>
                     : null}
               </Menu>
            </Grid>
         </div>
         <div className="main">
            {children}
         </div>

         {false !== footer && <Footer />}
      </div>
   )
}

Layout.propTypes = {
   routes:   React.PropTypes.array.isRequired,
   children: React.PropTypes.node.isRequired,
   footer:   React.PropTypes.bool,
   auth:     React.PropTypes.object,
   location: React.PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// lib/ui/Layout.jsx